<template>
  <div>
    <div :class="bgFlag?'tarnsf':''">
      <div class="iheader"
           :class="moveFlag?'bgColor':''">
        <h1 class="ihed_h1">
          <img src="~@/assets/images/svg/logo_top_black.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="!bgFlag" />
          <img src="~@/assets/images/svg/logo_top_white.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="bgFlag" />
        </h1>
        <div class="herg">
          <span class="herg_lang"
                @click='changeLang()'>{{lang}}</span>
          <i class="herg_mu"
             @click="nuneClick(1)"></i>
        </div>
      </div>
    </div>
    <div class="hdplace"></div>
    <div class="imageList">
      <div class="bread">
        <div class="breSel"
             v-show="selFlag">
          <div class="breSel_inner">
            <p class="breSel_p"
               v-for="(item,index) in papList"
               @click="changeList(item)"
               :key="'pap'+index"> {{item.title}}</p>
          </div>

        </div>
        <div class="bread_lf"
             :class="selFlag ?'active':''"
             @click="conChange()">
          <span class="bread_nu">{{papName}}</span>
          <i class="sel_ico"></i>

        </div>
        <div class="bread_rg">
          <transition name="fade">
            <i class="fg"
               @click="imageChange()"
               v-show="imageShow"></i>
          </transition>
          <transition name="fade">
            <i class="rgmu"
               @click="wzChange()"
               v-show="wzShow"></i>
          </transition>

        </div>
      </div>
      <div class="jdCon">
        <div class="jdCon_tp clearfix">
          <div class="jdCon_lf">
            <p class="jdCon_tp_na fontS">{{papName}}</p>
          </div>
          <div class="jdCon_rg">
            <div class="jdCon_rg_p"
                 v-html="papDes">
            </div>
          </div>
        </div>
        <div class="jdCon_bd clearfix"
             v-show="imageShow">
          <van-list v-model="loading"
                    :finished="finished"
                    :offset="offset"
                    finished-text="没有更多了"
                    @load="onLoad">
            <div class="clearfix">
              <div class="jdCon_li "
                   :class="'jdCon_li'+(index+1)%8"
                   v-for="(item,index) in boxList"
                   :key="'jdc'+index"
                   @click="towkDetail(item.id)">
                <div class="jdCon_li_inner">
                  <van-image fit="cover"
                             :src="item.pic"
                             class="li_img">
                    <template v-slot:loading>
                      <van-loading type="spinner"
                                   size="0" />
                    </template>
                  </van-image>
                  <!-- <img :src="item.pic"
                       class="li_img" /> -->
                </div>
                <div class="jdCon_li_mask"></div>
                <div class="jdCon_li_bt">
                  <p class="jdCon_li_p1 fontS">{{item.title}}</p>
                  <p class="jdCon_li_p2">{{item.location}},{{item.year}}</p>
                </div>
              </div>
            </div>
          </van-list>
          <div class="newLoading"
               v-show="loadFlag"><span>{{langFlag ?'loading':'正在加载中' }}~</span></div>

          <!-- <div class="jdCon_li jdCon_li2"
               @click="towkDetail()">
            <div class="jdCon_li_inner">
              <img src="~@/assets/images/li_img2.jpg"
                   class="li_img" />
            </div>
            <div class="jdCon_li_mask"></div>
            <div class="jdCon_li_bt">
              <p class="jdCon_li_p1">鼎赞酒店</p>
              <p class="jdCon_li_p2"> 宁波 中国, 2018</p>
            </div>
          </div>
          <div class="jdCon_li jdCon_li3"
               @click="towkDetail()">
            <div class="jdCon_li_inner">
              <img src="~@/assets/images/li_img3.jpg"
                   class="li_img" />
            </div>
            <div class="jdCon_li_mask"></div>
            <div class="jdCon_li_bt">
              <p class="jdCon_li_p1">七仙岭君澜度假酒店雨林西餐厅
              </p>
              <p class="jdCon_li_p2"> 宁波 中国, 2018</p>
            </div>
          </div>
          <div class="jdCon_li jdCon_li4"
               @click="towkDetail()">
            <div class="jdCon_li_inner">
              <img src="~@/assets/images/li_img4.jpg"
                   class="li_img" />
            </div>
            <div class="jdCon_li_mask"></div>
            <div class="jdCon_li_bt">
              <p class="jdCon_li_p1">三亚丽禾温德姆酒店</p>
              <p class="jdCon_li_p2"> 宁波 中国, 2018</p>
            </div>
          </div>
          <div class="jdCon_li jdCon_li5"
               @click="towkDetail()">
            <div class="jdCon_li_inner">
              <img src="~@/assets/images/li_img5.jpg"
                   class="li_img" />
            </div>
            <div class="jdCon_li_mask"></div>
            <div class="jdCon_li_bt">
              <p class="jdCon_li_p1">香水湾君澜度假酒店
                茶书吧</p>
              <p class="jdCon_li_p2"> 宁波 中国, 2018</p>
            </div>
          </div>
          <div class="jdCon_li jdCon_li6"
               @click="towkDetail()">
            <div class="jdCon_li_inner">
              <img src="~@/assets/images/li_img6.jpg"
                   class="li_img" />
            </div>
            <div class="jdCon_li_mask"></div>
            <div class="jdCon_li_bt">
              <p class="jdCon_li_p1">江山万里云酒店</p>
              <p class="jdCon_li_p2"> 宁波 中国, 2018</p>
            </div>
          </div>
          <div class="jdCon_li jdCon_li7"
               @click="towkDetail()">
            <div class="jdCon_li_inner">
              <img src="~@/assets/images/li_img7.jpg"
                   class="li_img" />
            </div>
            <div class="jdCon_li_mask"></div>
            <div class="jdCon_li_bt">
              <p class="jdCon_li_p1">三亚丽禾温德姆酒店</p>
              <p class="jdCon_li_p2"> 宁波 中国, 2018</p>
            </div>
          </div>
          <div class="jdCon_li jdCon_li8"
               @click="towkDetail()">
            <div class="jdCon_li_inner">
              <img src="~@/assets/images/li_img8.jpg"
                   class="li_img" />
            </div>
            <div class="jdCon_li_mask"></div>
            <div class="jdCon_li_bt">
              <p class="jdCon_li_p1">鼎赞酒店</p>
              <p class="jdCon_li_p2"> 宁波 中国, 2018</p>
            </div>
          </div> -->
        </div>
        <div class="wzCon_bd clearfix"
             v-show="wzShow">
          <van-list v-model="loading"
                    :finished="finished"
                    :offset="offset"
                    finished-text="没有更多了"
                    @load="onLoad">
            <div class="clearfix mgb60">
              <div class="wzList_li"
                   v-for="(item,index) in boxList"
                   :key="'box'+index"
                   @click="towkDetail(item.id)">
                <!-- <van-image fit="cover"
                           Lazyload
                           :src="item.pic"
                           class="dwt_img">
                </van-image> -->
                <div class="dwtbgt">
                  <img :src="item.pic"
                       class="dwt_img" />
                </div>

                <p class="wzList_li_p1 fontS">{{item.title}}</p>
                <p class="wzList_li_p2">{{item.location}},{{item.year}}</p>
              </div>
            </div>
          </van-list>
          <div class="newLoading"
               v-show="loadFlag"><span>{{langFlag ?'loading':'正在加载中' }}~</span></div>

          <!-- <div class="wzList_li"
               @click="towkDetail()">
            <p class="wzList_li_p1">鼎赞酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li"
               @click="towkDetail()">
            <p class="wzList_li_p1">七仙岭君澜度假酒店 雨林西餐厅 </p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li"
               @click="towkDetail()">
            <p class="wzList_li_p1">江山万里云酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li"
               @click="towkDetail()">
            <p class="wzList_li_p1">香⽔湾君澜度假酒店 茶书吧</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li"
               @click="towkDetail()">
            <p class="wzList_li_p1">三亚丽禾温德姆酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li"
               @click="towkDetail()">
            <p class="wzList_li_p1">鼎赞酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li"
               @click="towkDetail()">
            <p class="wzList_li_p1">江山万里云酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li"
               @click="towkDetail()">
            <p class="wzList_li_p1">三亚丽禾温德姆酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li"
               @click="towkDetail()">
            <p class="wzList_li_p1">江山万里云酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div> -->
        </div>

      </div>
      <gotop></gotop>
      <!-- footer -->
      <!-- footer -->
      <foot @contact="contact"></foot>
      <transition name="slide-fade">
        <munePage v-show="muneFlag"
                  :muneFlag="muneFlag"
                  :muneIndex="muneIndex"
                  @closeMu="closeMu"></munePage>
      </transition>
    </div>
  </div>

</template>

<script>
import { WOW } from 'wowjs'
import foot from '@/components/foot.vue'
import gotop from '@/components/goTop.vue'
import munePage from '@/pages/munePage.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      bgFlag: false,
      imageShow: true,
      wzShow: false,
      mySwiper: null,
      muneFlag: false,
      muneIndex: 1,
      selFlag: false,
      papName: '',
      papDes: '',
      papList: [],
      moveFlag: false,
      id: '',
      boxList: [],
      pageNum: 0, // 当前页码
      pageSize: 10, // 分页大小
      total: 0, // 查询总条数
      loading: false, // 滚动加载中
      finished: false, // 滚动加载完成
      offset: 300, //滚动条与底部距离小于 offset 时触发load事件，默认300
      index: 0,
      contTit: '作品列表',
      loadFlag: false,
    }
  },
  components: { foot, gotop, munePage },
  mounted() {
    this.id = this.$route.query.id || ''
    document.title = this.contTit
    this.projectCate()
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false,
      })
      wow.init()

      // 滚动条滚动
      window.addEventListener('scroll', this.handleScroll)
    })
  },
  computed: {
    ...mapState(['langFlag', 'lang']),
  },
  watch: {
    langFlag(val) {
      console.log('中英文的值', val)
      this.boxList = []
      this.pageNum = 0
      this.papName = ''
      this.papDes = ''
      this.id = ''
      this.projectCate()
      if (val) {
        this.contTit = 'list'
        document.title = this.contTit
      } else {
        this.contTit = '作品列表'
        document.title = this.contTit
      }
    },
  },
  methods: {
    imageChange() {
      this.imageShow = false
      this.wzShow = true
    },
    wzChange() {
      this.imageShow = true
      this.wzShow = false
    },
    // 菜单
    nuneClick(index) {
      this.muneFlag = true
      this.muneIndex = 1
    },
    closeMu(val) {
      this.muneFlag = false
      this.boxList = []
      this.pageNum = 0
      this.papName = ''
      this.papDes = ''
      this.id = val
      this.projectCate()
    },
    contact() {
      this.muneFlag = true
      this.muneIndex = 3
    },
    towkDetail(detailId) {
      this.$router.push({
        name: 'works',
        query: {
          detailId: detailId,
        },
      })
    },
    conChange() {
      this.selFlag = !this.selFlag
    },
    changeList(val) {
      this.papName = val.title
      this.papDes = val.desp
      this.id = val.id
      this.boxList = []
      this.pageNum = 0
      this.projects(this.id)
      this.selFlag = false
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight
      var scroll = scrollTop - this.i
      this.i = scrollTop
      if (scroll <= 0) {
        this.moveFlag = false
        console.log('不执行')
      } else {
        this.moveFlag = true
        console.log('执行')
      }
      if (scrollTop < winH) {
        this.bgFlag = false
      } else {
        this.bgFlag = true
      }

      // let t1 = document.documentElement.scrollTop || document.body.scrollTop
      // if (t1 > 10) {
      //   this.moveFlag = true
      // } else {
      //   this.moveFlag = false
      // }
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? 'CH' : 'EN')
      console.log('语言', this.langFlag)
    },
    // 返回首页
    toHome() {
      this.$router.push({
        name: 'home',
        // query: {
        //   type: type,
        // },
      })
    },

    // 获取产品分类
    projectCate() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'projectCate',
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            console.log('ddd', that.id)
            that.papList = response.data
            if (!that.id) {
              that.papName = that.papList[0].title
              that.papDes = that.papList[0].desp
              that.id = that.papList[0].id
              console.log('ddd222', that.id)
            } else {
              console.log('ddd333', that.id)
              that.papList.forEach(function (item, index) {
                if (item.id == that.id) {
                  that.papName = item.title
                  that.papDes = item.desp
                }
              })
            }

            that.projects(that.id)
            console.log('ddd', that.boxList)
          }
        })
        .catch(function (error) {})
    },
    // 获取产品列表
    projects(id) {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'projects',
        that.$qs.stringify({
          type: type,
          cateId: id,
          page: that.pageNum,
          size: 4,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            that.total = response.data.total //总页数

            let allNum = that.pageNum + 1
            if (allNum > that.total) {
              // that.finished = true
              that.loadFlag = false
              alet(0)
            } else {
              that.boxList = that.boxList.concat(response.data.data) || []
              // that.finished = false
              that.loadFlag = true
              that.pageNum = that.pageNum + 1
            }
            that.loading = false
            that.loadFlag = false
          }
        })
        .catch(function (error) {})
    },

    // 滚动加载更多
    onLoad() {
      let that = this
      // this.loading = true
      this.loadFlag = true
      if (this.boxList.length > 0) {
        setTimeout(function () {
          that.projects(that.id)
        }, 300)
      }
    },
    toGoodsDetail(id) {
      this.$router.push({
        name: 'middlePage',
        query: {
          id: id,
        },
      })
    },
  },
}
</script>
<style >
.van-list__finished-text {
  text-align: center !important;
}
.van-list__error-text,
.van-list__finished-text,
.van-list__loading {
  display: none;
}
</style>

<style >
.van-loading__text {
  opacity: 0;
}
</style>





// WEBPACK FOOTER //
// src/pages/imageList.vue